<script>
import {notificationMethods, contractMethods, contractPaymentMethods, contractProductMethods, productMethods} from "@/state/helpers";

import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import Cookies from "js-cookie";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Evrak Hareketleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      productsLoaded:false,
      paymentsLoaded:false,
      paymentMethodsLoaded:false,
      productMethodsLoaded:false,
      contractLoaded:false,
      paymentMethods: [],
      payments:[],
      productMethods: [],
      contract: {},
      paid:false,
      currentUser:JSON.parse(Cookies.get('user')),
      formSelectProducts:[],
      title: "Evrak Hareketleri",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Evraklar",
          href: "/contracts"
        },
        {
          text: "Evrak Hareketleri",
          active: true,
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      productMethodsAddModal: false,
      productMethodsEditModal:false,
      productMethodsDeleteModal:false,

      paymentMethodsAddModal: false,
      paymentMethodsEditModal:false,
      paymentMethodsDeleteModal:false,
      contractFormModal:false,

      addPaymentModal:false,
      addDiscountModal:false,
      addDownPaymentModal:false,

      productMethodsEditId:'',
      productMethodsDeleteId:{id:'',productId:''},
      paymentMethodsEditId:'',
      paymentMethodsDeleteId:'',

      productMethodsEditSubmitted:false,
      productMethodsAddSubmitted:false,
      paymentMethodsEditSubmitted:false,
      paymentMethodsAddSubmitted:false,
      addPaymentSubmitted:false,
      addDiscountSubmitted:false,
      addDownPaymentSubmitted:false,

      productMethodsEditForm:{
        quantity:''
      },
      productMethodsAddForm:{
        productId:'',
        quantity:''
      },
      addPaymentForm:{
        amount:'',
        paymentDate:''
      },
      addDiscountForm:{
        discountAmount:'',
        installment:''
      },
      addDownPaymentForm:{
        amount:'',
        paymentDate:''
      },
      paymentMethodsEditForm:{
        installmentDate:'',
        amount:'',
        pay:''
      },
      paymentMethodsAddForm:{
        installmentDate:'',
        amount:''
      },

      productMethodsTotalRows: 1,
      productMethodsPage: 1,

      perPage: 10,

      pageOptions: [10, 25, 50, 100],
      filter: null,

      filterOn: [],

      sortBy: "createdAt",
      sortDesc: false,
      paymentFields: [
        {
          key: "amount",
          label: "Tutar",
        },
        {
          key: "paymentDate",
          label: "Ödendiği Tarih",
        },
        {
          key: "createdAt",
          label: "Oluşturulma Tarihi",
        },
        {
          key: "_user.name",
          label: "Kullanıcı",
        },
      ],
      paymentMethodsFields: [
        {
          key: "installmentDate",
          label: "Ödeme Tarihi",
        },
        {
          key: "paymentDate",
          label: "Ödendiği Tarih",
        },
        {
          key: "amount",
          label: "Tutar",
        },
        {
          key: "pay",
          label: "Ödenmiş Tutar",
        },
        {
          key: "status",
          label: "Ödenme Durumu",
        },
        {
          key: "edit",
          label:"Düzenle",
        },
        {
          key: "delete",
          label:"Sil",
        },
      ],
      productMethodsFields: [
        {
          key: "productId",
          label: "Ürün",
        },
        {
          key: "quantity",
          label: "Adet",
        },
        {
          key: "edit",
          label:"Düzenle",
        },
        {
          key: "delete",
          label:"Sil",
        },
      ],
      prevCount:0,
      productCount:0
    };
  },
  validations: {
    productMethodsEditForm: {
      quantity:{required}
    },
    productMethodsAddForm:{
      productId:{required},
      quantity:{required}
    },
    paymentMethodsEditForm:{
      installmentDate:{required},
      amount:{required},
      pay:{required},
    },
    paymentMethodsAddForm:{
      installmentDate:{required},
      amount:{required}
    },
    addPaymentForm:{
      amount:{required},
      paymentDate:{required}
    },
    addDiscountForm:{
      discountAmount:{required},
      installment:{required}
    },
    addDownPaymentForm:{
      amount:{required},
      paymentDate:{required}
    },
  },

  watch:{
    contract(newContract){
      this.title+= ` (${newContract.contractNumber})`
    }
  },

  mounted() {
    this.getContract();
    this.getPayments();
    this.getPaymentMethods();
    this.getProductMethods();
  },

  methods: {
    ...contractMethods,
    ...contractPaymentMethods,
    ...contractProductMethods,
    ...notificationMethods,
    ...productMethods,

    getPayments(){
      this.paymentsLoaded=false;
      this.fetchPaymentLogs({contractId: this.$route.params.contractId}).then(res=>{
        this.payments = res.docs;
        this.paymentsLoaded=true;
      })
    },

    getPaymentMethods(){
      this.paymentMethodsLoaded=false;
      this.fetchContractPayments({contractId: this.$route.params.contractId}).then(res=>{
        this.paid=false;
        res.docs.map(doc=>{
          if(doc.status==1){
            this.paid=true;
          }
        })

        this.paymentMethods = res.docs;
        this.paymentMethodsLoaded=true;
      })
    },

    calculateProductCount(diff){
      if(diff){
        this.productCount += diff;
      }else{
        this.productCount = this.contract.products.length>1 ? this.contract.products.reduce((prev,curr)=>prev.quantity+curr.quantity) : this.contract.products[0].quantity
      }
    },

    getProductsForFormSelect(opr='',id='') {
      this.productsLoaded=false;
      this.fetchProducts({listType:'select'}).then(res=>{
        let productIds = this.contract.products.map(product=> product.productId._id)
        if(opr){
          if(opr=='add'){
            productIds.push(id)
          }else if(opr=='delete'){
            productIds = productIds.filter(productId => productId!=id)
          }
        }
        this.formSelectProducts = res.docs.filter(doc=>!productIds.includes(doc.id));

        this.productsLoaded=true;
      })
    },

    getProductMethods(page=this.productMethodsPage){
      this.productMethodsLoaded=false;
      this.fetchContractProducts({contractId: this.$route.params.contractId , page, limit:this.perPage}).then(res=>{
        this.productMethodsTotalRows = res.total;
        // getting category ready for fields
        this.productMethods = res.docs.map(elem=>{
          return elem;
        })
        this.productMethodsLoaded=true;
      })
    },

    getContract(){
      this.contractLoaded=false;
      this.fetchContract({id: this.$route.params.contractId}).then(res=>{
        this.contract = res
        this.contractLoaded=true;
        this.getProductsForFormSelect();
        this.calculateProductCount()
      })
    },

    handleProductMethodsAddSubmit(){
      this.productMethodsAddSubmitted = true;
      this.$v.productMethodsAddForm.$touch();
      if (
          this.$v.productMethodsAddForm.$invalid
      ) {
        return;
      } else {
        this.createContractProduct({contractId: this.$route.params.contractId,data:this.productMethodsAddForm}).then((res)=>{
          this.toastMessage="Ürün başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.productMethodsAddModal = false;
          this.getProductMethods();
          this.getProductsForFormSelect('add',res.productId);
          this.calculateProductCount(res.quantity)
          this.productMethodsAddForm.productId = "";
          this.productMethodsAddForm.quantity = "";
        })
      }
    },
    handleProductMethodsEditSubmit(){
      this.productMethodsEditSubmitted = true;
      this.$v.productMethodsEditForm.$touch();
      if (
          this.$v.productMethodsEditForm.$invalid || isNaN(this.productMethodsEditForm.quantity )
      ) {
        return;
      } else {
        this.updateContractProduct({contractId: this.$route.params.contractId,id:this.productMethodsEditId,data:this.productMethodsEditForm}).then((res)=>{
          this.toastMessage="Ürün başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.productMethodsEditModal = false;
          this.getProductMethods();
          this.calculateProductCount(res.quantity-this.prevCount)
          this.productMethodsEditForm.quantity = "";
        })
      }
    },
    handleProductMethodsDeleteSubmit(){
      this.deleteContractProduct({contractId: this.$route.params.contractId,id:this.productMethodsDeleteId.id}).then(()=>{
        this.productMethodsDeleteModal = false;
        this.toastMessage="Ürün başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.calculateProductCount(-this.productMethods.filter(product=>product.id==this.productMethodsDeleteId.id)[0].quantity)
        this.getProductMethods();
        this.getProductsForFormSelect('delete',this.productMethodsDeleteId.productId);
      })
    },
    handleAddPaymentSubmit(){
      this.addPaymentSubmitted = true;
      this.$v.addPaymentForm.$touch();
      if (
          this.$v.addPaymentForm.$invalid || isNaN(this.addPaymentForm.amount)
      ) {
        return;
      } else {
        this.payInstallment({contractId: this.$route.params.contractId,data:this.addPaymentForm}).then(()=>{
          this.toastMessage="Ödeme başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.addPaymentModal = false;
          this.getPaymentMethods();
          this.getPayments()
          this.addPaymentForm.paymentDate = "";
          this.addPaymentForm.amount = "";
        })
      }
    },
    handleAddDiscountSubmit(){
      this.addDiscountSubmitted = true;
      this.$v.addDiscountForm.$touch();
      if (
          this.$v.addDiscountForm.$invalid || isNaN(this.addDiscountForm.discountAmount)
      ) {
        return;
      } else {
        this.makeDiscount({contractId: this.$route.params.contractId,data:this.addDiscountForm}).then(()=>{
          this.toastMessage="İnidirim başarıyla uygulandı!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.addDiscountModal = false;
          this.getPaymentMethods();
          this.getPayments()
          this.addDiscountForm.installment = "";
          this.addDiscountForm.discountAmount = "";
        })
      }
    },
    handleAddDownPaymentSubmit(){
      this.addDownPaymentSubmitted = true;
      this.$v.addDownPaymentForm.$touch();
      if (
          this.$v.addDownPaymentForm.$invalid || isNaN(this.addDownPaymentForm.amount)
      ) {
        return;
      } else {

        this.downPay({contractId: this.$route.params.contractId,data:this.addDownPaymentForm}).then(()=>{
          this.toastMessage="Peşinat başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.addDownPaymentModal = false;
          this.getPaymentMethods();
          this.getPayments()
          this.addDownPaymentForm.paymentDate = "";
          this.addDownPaymentForm.amount = "";
        })
      }
    },
    handlePaymentMethodsAddSubmit(){
      this.paymentMethodsAddSubmitted = true;
      this.$v.paymentMethodsAddForm.$touch();
      if (
          this.$v.paymentMethodsAddForm.$invalid || isNaN(this.paymentMethodsAddForm.amount)
      ) {
        return;
      } else {
        this.createContractPayment({contractId: this.$route.params.contractId,data:this.paymentMethodsAddForm}).then(()=>{
          this.toastMessage="Taksit başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.paymentMethodsAddModal = false;
          this.getPaymentMethods();
          this.getPayments();
          this.paymentMethodsAddForm.installmentDate = "";
          this.paymentMethodsAddForm.amount = "";
        })
      }
    },
    handlePaymentMethodsEditSubmit(){
      this.paymentMethodsEditSubmitted = true;
      this.$v.paymentMethodsEditForm.$touch();

      if (
          this.$v.paymentMethodsEditForm.$invalid ||  isNaN(this.paymentMethodsEditForm.amount) || isNaN(this.paymentMethodsEditForm.pay)
      ) {
        return;
      } else {
        this.updateContractPayment({contractId: this.$route.params.contractId,id:this.paymentMethodsEditId,data:this.paymentMethodsEditForm}).then(()=>{
          this.toastMessage="Taksit başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.paymentMethodsEditModal = false;
          this.getPaymentMethods();
          this.getPayments();
          this.paymentMethodsEditForm.installmentDate = "";
          this.paymentMethodsEditForm.amount = "";
          this.paymentMethodsEditForm.pay = "";
        })
      }
    },
    handlePaymentMethodsDeleteSubmit(){
      this.deleteContractPayment({contractId: this.$route.params.contractId,id:this.paymentMethodsDeleteId}).then(()=>{
        this.paymentMethodsDeleteModal = false;
        this.toastMessage="Taksit başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getPaymentMethods();
        this.getPayments();
      })
    },

    openProductMethodsEdit(product) {
      this.productMethodsEditForm.quantity = product.quantity;
      this.productMethodsEditId = product.id;
      this.prevCount = product.quantity;
      this.productMethodsEditModal = true;
    },
    openProductMethodsDelete(product) {
      this.productMethodsDeleteId.id = product.id;
      this.productMethodsDeleteId.productId = product.productId._id;
      this.productMethodsDeleteModal = true;
    },
    openPaymentMethodsEdit(payment) {
      this.paymentMethodsEditForm.installmentDate = payment.installmentDate.split('T')[0];
      this.paymentMethodsEditForm.amount = payment.amount;
      this.paymentMethodsEditForm.pay = payment.pay;
      this.paymentMethodsEditId = payment.id;
      this.paymentMethodsEditModal = true;
    },
    openPaymentMethodsDelete(payment) {
      this.paymentMethodsDeleteId = payment.id;
      this.paymentMethodsDeleteModal = true;
    },
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div  class="row" >

      <div v-if="this.contract.customerId" class="col-12">
        <div class="card">
          <div class="card-body gap-3 d-flex align-items-center">
            <div>
              <img @click="contractFormModal=true" :style="{cursor:'pointer' ,width:'120px!important', objectFit:'contain'}" height="250"  :src="contract.contractForm" alt="Evrak formu">
            </div>
            <div class="d-flex w-100">
              <div class="table-responsive col-6">
                <table class="table table-nowrap mb-0">
                  <tbody>
                  <tr>
                    <th scope="row">Müşteri :</th>
                    <td>{{this.contract.customerId.name}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Evrak Tarihi :</th>
                    <td>{{this.contract.contractDate | formatTurkishLongDate}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tutar :</th>
                    <td>{{moneyFormat(this.contract.discountedAmount)}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Toplam Taksit Tutarı :</th>
                    <td>{{moneyFormat(this.contract.installmentAmount)}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Plasiyer :</th>
                    <td>{{this.contract.personId.name}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Evrağı Ekleyen :</th>
                    <td>{{this.contract.createdBy ? this.contract.createdBy.name : '-'}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Kampanya Kodu :</th>
                    <td>{{this.contract.campaignCode ? this.contract.campaignCode : '-'}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-responsive col-6">
                <table class="table table-nowrap mb-0">
                  <tbody>
                  <tr>
                    <th scope="row">Müşterek :</th>
                    <td>{{this.contract.jointCustomerId ? this.contract.jointCustomerId.name :'-'}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Teslim Tarihi :</th>
                    <td>{{this.contract.deliveryTime | formatTurkishLongDate}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Ödenen Tutar :</th>
                    <td>{{moneyFormat(this.contract.installmentPay)}}</td>
                  </tr>
                  <tr>
                    <th scope="row">Kalan Tutar:</th>
                    <td>{{moneyFormat(this.contract.installmentAmount-this.contract.installmentPay)}}</td>
                  </tr>
                  <tr>
                    <th scope="row">İndirim Oranı :</th>
                    <td>{{this.contract.discountRate}}%</td>
                  </tr>
                  <tr>
                    <th scope="row">Gecikmiş Ödeme :</th>
                    <td>{{moneyFormat(this.contract.delayedPayment)}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="paymentMethodsLoaded" class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex justify-content-between align-items-center">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Ödeme Yöntemleri</h5>
                </div>

                <div class="d-flex gap-4">
                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-info ms-auto mb-2"
                      @click="addDiscountModal = true"
                  >
                    İndirim Uygula
                  </button>

                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-success ms-auto mb-2"
                      @click="addPaymentModal = true"
                  >
                    Ödeme Ekle
                  </button>

                  <button
                      :disabled="currentUser.role.includes('user')"
                      class="btn btn-secondary ms-auto mb-2"
                      @click="addDownPaymentModal = true"
                  >
                    Peşinat Ekle
                  </button>

                  <button
                      :disabled="(currentUser.role.includes('user') || paid || this.contract.status==0) ? true : false"
                      class="btn btn-outline-dark ms-auto mb-2"
                      @click="paymentMethodsAddModal = true"
                  >
                    Taksit Ekle
                  </button>
                </div>

              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="paymentMethods"
                  :fields="paymentMethodsFields"
                  responsive="sm"
              >
                <template v-slot:cell(installmentDate)="data">
                  {{ new Date(data.item.installmentDate).toDateString() | formatDate}}
                </template>
                <template v-slot:cell(amount)="data">
                  {{moneyFormat(data.item.amount)}}
                </template>
                <template v-slot:cell(pay)="data">
                  {{moneyFormat(data.item.pay)}}
                </template>
                <template v-slot:cell(paymentDate)="data">
                  {{data.item.paymentDate && new Date(data.item.paymentDate).toDateString() | formatDate}}
                </template>
                <template v-slot:cell(status)="data">
                  <td v-if="data.item.status==1" class="align-middle">
                    <span class="badge badge-pill badge-soft-success font-size-13">Ödendi</span>
                  </td>
                  <td v-else class="align-middle">
                    <span class="badge badge-pill badge-soft-danger font-size-13">Ödenmedi</span>
                  </td>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      :disabled="(currentUser.role.includes('user') || contract.status==0) ? true : false"
                      class="btn btn-warning d-flex py-2"
                      @click="openPaymentMethodsEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="(currentUser.role.includes('user') || paid || contract.status==0) ? true : false"
                      class="btn btn-danger d-flex py-2"
                      @click="openPaymentMethodsDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="spinner-wrapper" v-else>
        <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
      </div>

      <div v-if="productsLoaded && productMethodsLoaded" class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Ürünler</h5>
                </div>

                <button
                    :disabled="(currentUser.role.includes('user')  || contract.status==0  ) ? true : false"
                    v-if="formSelectProducts && formSelectProducts.length>0"
                    class="btn btn-success ms-auto mb-2"
                    @click="productMethodsAddModal = true"
                >
                  Ürün Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="productMethods"
                  :fields="productMethodsFields"
                  responsive="sm"
              >
                <template v-slot:cell(productId)="data">
                  {{data.item.productId.name}}
                </template>
                <template v-slot:cell(status)="data">
                  <td v-if="data.item.status==1" class="align-middle">
                    <span class="badge badge-pill badge-soft-success font-size-13">Ödendi</span>
                  </td>
                  <td v-else class="align-middle">
                    <span class="badge badge-pill badge-soft-danger font-size-13">Ödenmedi</span>
                  </td>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      :disabled="(currentUser.role.includes('user') || contract.status==0 || paid) ? true : false"
                      class="btn btn-warning d-flex py-2"
                      @click="openProductMethodsEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      :disabled="(currentUser.role.includes('user') || contract.status==0 || paid) ? true : false"
                      class="btn btn-danger d-flex py-2"
                      @click="openProductMethodsDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>

      <div class="spinner-wrapper" v-else>
        <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
      </div>

      <div class="col-12" v-if="paymentsLoaded">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <h5>Ödemeler</h5>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="payments"
                  :fields="paymentFields"
                  responsive="sm"
              >
                <template v-slot:cell(amount)="data">
                  {{moneyFormat(data.item.amount)}}
                </template>
                <template v-slot:cell(paymentDate)="data">
                  {{ new Date(data.item.paymentDate).toDateString() | formatDate}}
                </template>
                <template v-slot:cell(createdAt)="data">
                  {{ new Date(data.item.createdAt).toDateString() | formatDate}}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>

      <div class="spinner-wrapper" v-else>
        <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
      </div>

      <b-modal v-model="productMethodsEditModal" title="Ürün Düzenle" hide-footer>
        <form @submit.prevent="handleProductMethodsEditSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="quantity">Adet</label>
                <input
                    id="quantity"
                    type="text"
                    v-model="productMethodsEditForm.quantity"
                    class="form-control"
                    placeholder="Adet Giriniz"
                    :class="{
                    'is-invalid': productMethodsEditSubmitted && ($v.productMethodsEditForm.quantity.$error || isNaN(productMethodsEditForm.quantity)),
                  }"
                />
                <div
                    v-if="productMethodsEditSubmitted && !$v.productMethodsEditForm.quantity.required"
                    class="invalid-feedback"
                >
                  Adet girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="productMethodsEditSubmitted && $v.productMethodsEditForm.quantity.required && isNaN(productMethodsEditForm.quantity )"
                    class="invalid-feedback"
                >
                  Adet alanına sayı girilmelidir.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="productMethodsEditModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal v-model="productMethodsAddModal"  v-if="formSelectProducts && formSelectProducts.length>0" title="Ürün Ekle" hide-footer>
        <form @submit.prevent="handleProductMethodsAddSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="product">Ürün</label>
                <select
                    name="product"
                    v-model="productMethodsAddForm.productId"
                    class="form-control"
                    :class="{
                    'is-invalid': productMethodsAddSubmitted && $v.productMethodsAddForm.productId.$error,
                  }"
                >
                  <option
                      v-for="product in formSelectProducts"
                      :key="product.id"
                      :value="product.id"
                  >{{product.name}}</option>
                </select>
                <div
                    v-if="productMethodsAddSubmitted && !$v.productMethodsAddForm.productId.required"
                    class="invalid-feedback"
                >
                  Ürün girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="quantity">Adet</label>
                <input
                    id="quantity"
                    type="text"
                    v-model="productMethodsAddForm.quantity"
                    class="form-control"
                    placeholder="Adet Giriniz"
                    :class="{
                    'is-invalid': productMethodsAddSubmitted && ($v.productMethodsAddForm.quantity.$error || isNaN(productMethodsAddForm.quantity ))
                  }"
                />
                <div
                    v-if="productMethodsAddSubmitted && !$v.productMethodsAddForm.quantity.required"
                    class="invalid-feedback"
                >
                  Adet girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="productMethodsAddSubmitted && $v.productMethodsAddForm.quantity.required && isNaN(productMethodsAddForm.quantity )"
                    class="invalid-feedback"
                >
                  Adet alanına sayı girilmelidir.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="productMethodsAddModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="productMethodsDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu ürünü sözleşmeden silmek istediğinize emin misiniz? Silinmiş ürünleri geri alamazsınız.
              </p>

              <form @submit.prevent="handleProductMethodsDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal v-model="paymentMethodsEditModal" title="Ödeme Düzenle" hide-footer>
        <form @submit.prevent="handlePaymentMethodsEditSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="amount">Tutar</label>
                <input
                    :disabled="paid ? true : false"
                    id="amount"
                    type="text"
                    v-model="paymentMethodsEditForm.amount"
                    class="form-control"
                    placeholder="Tutar Giriniz"
                    :class="{
                    'is-invalid': paymentMethodsEditSubmitted && ($v.paymentMethodsEditForm.amount.$error || isNaN(paymentMethodsEditForm.amount)),
                  }"
                />
                <div
                    v-if="paymentMethodsEditSubmitted && !$v.paymentMethodsEditForm.amount.required"
                    class="invalid-feedback"
                >
                  Tutar girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="paymentMethodsEditSubmitted && $v.paymentMethodsEditForm.amount.required && isNaN(paymentMethodsEditForm.amount)"
                    class="invalid-feedback"
                >
                  Tutar alanına sayı girilmelidir.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="amount">Ödenen Tutar</label>
                <input
                    id="amount"
                    type="text"
                    v-model="paymentMethodsEditForm.pay"
                    class="form-control"
                    placeholder="Tutar Giriniz"
                    :class="{
                    'is-invalid': paymentMethodsEditSubmitted && ($v.paymentMethodsEditForm.pay.$error || isNaN(paymentMethodsEditForm.pay)),
                  }"
                />
                <div
                    v-if="paymentMethodsEditSubmitted && !$v.paymentMethodsEditForm.pay.required"
                    class="invalid-feedback"
                >
                  Ödenen Tutar girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="paymentMethodsEditSubmitted && $v.paymentMethodsEditForm.pay.required && isNaN(paymentMethodsEditForm.pay)"
                    class="invalid-feedback"
                >
                  Ödenen Tutar alanına sayı girilmelidir.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="installmentDate">Ödeme Tarihi</label>
                <b-form-input
                    v-model="paymentMethodsEditForm.installmentDate"
                    id="installmentDate"
                    type="date"
                    :class="{
                      'is-invalid': paymentMethodsEditSubmitted && $v.paymentMethodsEditForm.installmentDate.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="paymentMethodsEditSubmitted && $v.paymentMethodsEditForm.installmentDate.$error"
                    class="invalid-feedback"
                >
                  Ödeme Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="paymentMethodsEditModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal v-model="paymentMethodsAddModal" title="Taksit Ekle" hide-footer>
        <form @submit.prevent="handlePaymentMethodsAddSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="amount">Tutar</label>
                <input
                    id="amount"
                    type="text"
                    v-model="paymentMethodsAddForm.amount"
                    class="form-control"
                    placeholder="Tutar Giriniz"
                    :class="{
                    'is-invalid': paymentMethodsAddSubmitted && ($v.paymentMethodsAddForm.amount.$error || isNaN(paymentMethodsAddForm.amount)),
                  }"
                />
                <div
                    v-if="paymentMethodsAddSubmitted && !$v.paymentMethodsAddForm.amount.required"
                    class="invalid-feedback"
                >
                  Tutar girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="paymentMethodsAddSubmitted && $v.paymentMethodsAddForm.amount.required && isNaN(paymentMethodsAddForm.amount)"
                    class="invalid-feedback"
                >
                  Tutar alanına sayı girilmelidir.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="installmentDate">Ödeme Tarihi</label>
                <b-form-input
                    v-model="paymentMethodsAddForm.installmentDate"
                    id="installmentDate"
                    type="date"
                    :class="{
                      'is-invalid': paymentMethodsAddSubmitted && $v.paymentMethodsAddForm.installmentDate.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="paymentMethodsAddSubmitted && $v.paymentMethodsAddForm.installmentDate.$error"
                    class="invalid-feedback"
                >
                  Ödeme Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="paymentMethodsAddModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="paymentMethodsDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu taksiti sözleşmeden silmek istediğinize emin misiniz? Silinmiş ödemeleri geri alamazsınız.
              </p>

              <form @submit.prevent="handlePaymentMethodsDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>


      <b-modal v-model="addDiscountModal" title="İndirim Uygula" hide-footer>
        <form @submit.prevent="handleAddDiscountSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="amount">İndirim</label>
                <input
                    id="amount"
                    type="text"
                    v-model="addDiscountForm.discountAmount"
                    class="form-control"
                    placeholder="Tutar Giriniz"
                    :class="{
                    'is-invalid': addDiscountSubmitted && ($v.addDiscountForm.discountAmount.$error || isNaN(addDiscountForm.discountAmount)),
                  }"
                />
                <div
                    v-if="addDiscountSubmitted && !$v.addDiscountForm.discountAmount.required"
                    class="invalid-feedback"
                >
                  Tutar girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="addDiscountSubmitted && $v.addDiscountForm.discountAmount.required && isNaN(addDiscountForm.discountAmount)"
                    class="invalid-feedback"
                >
                  Tutar alanına sayı girilmelidir.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="amount">Toplam Taksit</label>
                <input
                    id="amount"
                    type="text"
                    v-model="addDiscountForm.installment"
                    class="form-control"
                    placeholder="Tutar Giriniz"
                    :class="{
                    'is-invalid': addDiscountSubmitted && ($v.addDiscountForm.installment.$error || isNaN(addDiscountForm.installment)),
                  }"
                />
                <div
                    v-if="addDiscountSubmitted && !$v.addDiscountForm.installment.required"
                    class="invalid-feedback"
                >
                 Taksit girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="addDiscountSubmitted && $v.addDiscountForm.installment.required && isNaN(addDiscountForm.installment)"
                    class="invalid-feedback"
                >
                  Taksit alanına sayı girilmelidir.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="addDiscountModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal v-model="addPaymentModal" title="Ödeme Ekle" hide-footer>
        <form @submit.prevent="handleAddPaymentSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="amount">Tutar</label>
                <input
                    id="amount"
                    type="text"
                    v-model="addPaymentForm.amount"
                    class="form-control"
                    placeholder="Tutar Giriniz"
                    :class="{
                    'is-invalid': addPaymentSubmitted && ($v.addPaymentForm.amount.$error || isNaN(addPaymentForm.amount)),
                  }"
                />
                <div
                    v-if="addPaymentSubmitted && !$v.addPaymentForm.amount.required"
                    class="invalid-feedback"
                >
                  Tutar girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="addPaymentSubmitted && $v.addPaymentForm.amount.required && isNaN(addPaymentForm.amount)"
                    class="invalid-feedback"
                >
                  Tutar alanına sayı girilmelidir.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="installmentDate">Ödendiği Tarih</label>
                <b-form-input
                    v-model="addPaymentForm.paymentDate"
                    id="installmentDate"
                    type="date"
                    :class="{
                      'is-invalid': addPaymentSubmitted && $v.addPaymentForm.paymentDate.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="addPaymentSubmitted && $v.addPaymentForm.paymentDate.$error"
                    class="invalid-feedback"
                >
                  Ödeme Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="addPaymentModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal v-model="addDownPaymentModal" title="Peşinat Ekle" hide-footer>
        <form @submit.prevent="handleAddDownPaymentSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="amount">Tutar</label>
                <input
                    id="amount"
                    type="text"
                    v-model="addDownPaymentForm.amount"
                    class="form-control"
                    placeholder="Tutar Giriniz"
                    :class="{
                    'is-invalid': addDownPaymentSubmitted && ($v.addDownPaymentForm.amount.$error || isNaN(addDownPaymentForm.amount)),
                  }"
                />
                <div
                    v-if="addDownPaymentSubmitted && !$v.addDownPaymentForm.amount.required"
                    class="invalid-feedback"
                >
                  Tutar girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="addDownPaymentSubmitted && $v.addDownPaymentForm.amount.required && isNaN(addDownPaymentForm.amount)"
                    class="invalid-feedback"
                >
                  Tutar alanına sayı girilmelidir.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="installmentDate">Ödendiği Tarih</label>
                <b-form-input
                    v-model="addDownPaymentForm.paymentDate"
                    id="installmentDate"
                    type="date"
                    :class="{
                      'is-invalid': addDownPaymentSubmitted && $v.addDownPaymentForm.paymentDate.$error,
                    }"
                ></b-form-input>
                <div
                    v-if="addDownPaymentSubmitted && $v.addDownPaymentForm.paymentDate.$error"
                    class="invalid-feedback"
                >
                  Ödeme Tarihi girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="addDownPaymentModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal v-model="contractFormModal" :hide-footer="true">
        <div>
          <img class="w-100" :src="contract.contractForm" alt="Evrak Formu">
        </div>
      </b-modal>

    </div>

  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
